    <div class="row">
        <div class="col-md-12">
            <div class="card card-accent-success">
                <div class="card-header-buscador">
                    <i class="fa fa-align-justify"></i> Listado de Periodos de Campañas
                </div>
    
                <div class="card-body-grid" *ngIf="result">
    
                    <p-table #tableSearch autoLayout="true" [value]="result?.ResultList" [lazy]="true"
                        [lazyLoadOnInit]="false" [rowHover]="true"
                        (onLazyLoad)="onSearchLazy($event)" [paginator]="true" [columns]="cols"
                        [rows]="result?.PageSize" sortOrder="0"
                        [totalRecords]="result?.TotalCount" [loading]="loading"
                        [ngClass]="displayGridHidden(result?.ResultList)"
                        styleClass="table table-responsive-sm  table-striped table-sm">
    
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}"
                                    [pSortableColumn]="col.field">
                                    {{col.header}}
                                    <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='Parcela' && col.field!=='Confeccion'
                                                && col.field!=='Invernadero' && col.field!=='EmpresaDeshidratacion'" [field]="col.field"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>
    
                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                            <tr>
                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    <span *ngIf="col.field === 'DescripcionCampania' || col.field === 'DescripcionPeriodo'">
                                        {{rowData[col.field]}}
                                    </span>                                        
                                    
                                    <span *ngIf="col.field==='FechaInicio'">{{ rowData[col.field] | date:'dd/MM/yyyy HH:mm' }}</span>
                                    <span *ngIf="col.field==='FechaFin'">{{ rowData[col.field] | date:'dd/MM/yyyy HH:mm' }}</span>
                                    <span *ngIf="col.field==='Parcela'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='Confeccion'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='Invernadero'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='EmpresaDeshidratacion'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='SuperficieMax'">{{ rowData[col.field] | number:'1.2-2':'es-ES' }}</span>
                                    <span *ngIf="col.field==='Dextrio'">{{ rowData[col.field] | number:'1.2-2':'es-ES' }}</span>
                                    <span *ngIf="col.field==='PresentarSolicitudesFueraPeriodo'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='ControlProduccionExportacion'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='HabilitadaTemporalmente'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='CicloCortoInspParcela'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='CicloCortoInspConfeccion'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='CicloCortoInspInvernadero'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='CicloCortoInspEmpresasDeshidratacion'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='RequiereFirmaInspectorPaisDestino'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='RequiereAvisoFechaConfeccion'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='TamanioMaximoAgrupacion'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='AvisoConfeccion'">{{ rowData[col.field] | siNo }}</span>
                                    <span *ngIf="col.field==='AmbitoNacional'">{{ rowData[col.field] | siNo }}</span>
                                    <div *ngIf="col.field==='Link'" class="btn-group">
                                        <!--EDITAR o CONSULTAR-->
                                        <div *ngIf="rowData['EsVisibleEdicion'] && !esPeriodoFinalizado(rowData)">
                                            <button (click)="onEdit(rowData)" type="button" class="btn btn-sm btn-warning" title="Editar">
                                                <span class="fa fa-edit"></span>
                                            </button>
                                        </div>
                                        <div *ngIf="!rowData['EsVisibleEdicion'] || esPeriodoFinalizado(rowData)">
                                            <button (click)="onEdit(rowData)" type="button" title="Consultar" placement="right" class="btn btn-sm btn-info">
                                                <span class="fa fa-eye"></span>
                                            </button>
                                        </div>
                                        <!--CLONAR-->
                                        <div *ngIf="checkClone() && EnabledCloned">
                                            <button (click)="onClone(rowData)" type="button" class="btn btn-sm btn-info" title="Clonar">
                                                <span class="fa fa-clone"></span>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    
                    <div *ngIf="tableSearch?.totalRecords" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                    <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                </div>

        </div>
    </div>
